<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="filter-table">
              <div class="filter-table-item">
                <div class="input-idade">
                  <label>De</label>
                  <input
                    type="text"
                    v-model="idade_inicial"
                    class="form-control"
                    placeholder="idade"
                  />
                  <label>a</label>
                  <input
                    type="text"
                    v-model="idade_final"
                    class="form-control"
                    placeholder="idade"
                  />
                </div>
              </div>
              <div class="filter-table-item">
                <select
                  name="sexo"
                  @change="onChangeSexo($event)"
                  class="form-control select-sexo"
                  v-model="sexo"
                >
                  <option value="" disabled selected>Sexo</option>
                  <option value="">Todos</option>
                  <option value="MASCULINO">Masculino</option>
                  <option value="FEMININO">Feminino</option>
                </select>
              </div>
            </div>
            <div class="info-table">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="exibirCadastrosVermelhos"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <vue-select
                  :options="groupFilterItems"
                  label="label"
                  placeholder="Grupos"
                  v-model="groupFilter"
                  :clearable="true"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="cadastros-cidadaos"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loadingLista"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
        <b-tab title="Mapa" @click="buscarDadosDoMapa()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <component-mapa
            :dadosDoMapaOriginal="dadosDoMapaOriginal"
            :dadosDoMapa="dadosDoMapa"
            :tabelaResultado="tabelaResultado"
            :equipe="equipe"
            :cadastros="displayedCadastros"
            ref="componentMapa"
          />
          <tabela-mapa :dados="dadosDoMapa"></tabela-mapa>
        </b-tab>
        <b-tab title="Percentual">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row">
            <div class="col-md-12">
              <!-- <div class="resultado-tabs2">
                <b-tabs
                  id="tabs-2"
                  key="tabs-2"
                  fill
                  class="esus-feedback-tabs"
                  v-model="tabsActive2"
                >
                  <b-tab title="resultado" active>
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Tabela"
                        class="icon-tooltip icofont-table"
                      ></i>
                    </template>
                  </b-tab>
                  <b-tab title="grafico" @click="abrirAbaResultadoGrafico()">
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Gráfico"
                        class="icon-tooltip icofont-chart-bar-graph"
                      ></i>
                    </template>
                  </b-tab>
                </b-tabs>
              </div> -->
              <!-- <div v-if="tabsActive2 === 1">
                <resultado-grafico
                  :cadastros="displayedCadastros"
                  :arrayChartMunicipio="arrayChartMunicipio"
                  :arrayChartEquipe="arrayChartEquipe"
                  :populacaoIbge="parseInt(populacaoIbge)"
                  :populacaoSisab="parseInt(totalCadastrosMunicipio)"
                  :populacaoSisabEquipe="parseInt(totalCadastrosEquipe)"
                  :temEquipe="true"
                  :temAcs="false"
                  :municipio="_municipio"
                  :equipe="_equipe"
                  :acs="_acs"
                  :minCadEquipe="parseInt(dadosSisabEquipe.min_cad)"
                  :maxCadEquipe="parseInt(dadosSisabEquipe.max_cad)"
                >
                </resultado-grafico>
              </div> -->
              <div v-if="tabsActive2 === 0">
                <div class="row mt-4">
                  <div class="col-lg-5">
                    <vue-select
                      name="situacao-cadastro"
                      v-model="indicadorResultado"
                      class="select-situacao-cadastro"
                      :clearable="false"
                      :options="optionsIndicador"
                      label="label"
                      placeholder="Situação cadastro"
                      @input="onChangeIndicadorResultado"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.label }}
                      </template>
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                  </div>
                </div>
                <tabela-resultado
                  :labelColunaAtualizados="labelColunaAtualizados"
                  :labelColunaDesatualizados="labelColunaDesatualizados"
                  :resetarSelectTabelaResultado="resetarSelectTabelaResultado"
                  :disabledSelectResultado="disabledSelectResultado"
                  :loading="loading"
                  :dadosResultadoMunicipio="dadosResultadoMunicipio"
                  :dadosResultadoEquipe="dadosResultadoEquipe"
                  :dadosResultadoMicroArea="dadosResultadoMicroArea"
                  :equipe="equipe"
                  :micro_area="micro_area"
                >
                </tabela-resultado>
                <grafico-resultado
                  :equipe="equipe"
                  :micro_area="micro_area"
                  :dadosSerieHistorica="dadosSerieHistorica"
                  ref="graficoResultado"
                ></grafico-resultado>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Escore">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Escore
          </template>
          <div class="row mt-4">
            <div class="col-lg-5">
              <vue-select
                name="situacao-cadastro"
                v-model="indicadorClassificacao"
                class="select-situacao-cadastro"
                :clearable="false"
                :options="optionsIndicadorClassificacao"
                label="label"
                placeholder="Situação cadastro"
                @input="onChangeIndicadorClassificacao"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div>
            <tabela-classificacao
              :equipe="equipe"
              :micro_area="micro_area"
              :dadosDoMunicipio="dadosMunicipioClassificacao"
              :dadosDaEquipe="dadosEquipeClassificacao"
              :dadosDaMicroArea="dadosMicroAreaClassificacao"
              :selectedIndicador="indicadorClassificacao"
            ></tabela-classificacao>
          </div>
          <div>
            <grafico-classificacao
              :equipe="equipe"
              :micro_area="micro_area"
              :dadosSerieHistorica="dadosSerieHistorica"
              ref="graficoClassificacao"
            ></grafico-classificacao>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import ResultadoGrafico from './ResultadoGrafico.vue'
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import {
  chartOptions,
  dataFields,
  groupFilterItems,
  optionsIndicador,
  optionsIndicadorClassificacao,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import TabelaResultado from './TabelaResultado.vue'
import GraficoResultado from './GraficoResultado.vue'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LPopup,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import TabelaClassificacao from './TabelaClassificacao.vue'
import GraficoClassificacao from './GraficoClassificacao.vue'
import TabelaMapa from './TabelaMapa.vue'
import ComponentMapa from './Mapa.vue'

export default {
  name: 'CadastrosIndividuais',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    Selects,
    'resultado-grafico': ResultadoGrafico,
    TabelaResultado,
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    LPopup,
    TabelaClassificacao,
    GraficoResultado,
    GraficoClassificacao,
    TabelaMapa,
    ComponentMapa,
  },
  mixins: [utils],
  data() {
    return {
      disabledSelectResultado: false,
      loadingGrafico: false,
      tabsActive: 0,
      tabsActive2: 0,
      micro_area: '',
      equipe: '',
      profissionais: [],
      cadastros: [],
      cadastrosOriginais: [],
      idade_inicial: '',
      idade_final: '',
      populacaoIbge: 0,
      totalCadastrosMunicipio: 0,
      totalCadastrosEquipe: '',
      parametro: '',
      dadosResultadoMunicipio: {
        total: 0,
        atualizados: 0,
        desatualizados: 0,
      },
      dadosResultadoEquipe: {
        total: 0,
        atualizados: 0,
        desatualizados: 0,
      },
      dadosResultadoMicroArea: {
        total: 0,
        atualizados: 0,
        desatualizados: 0,
      },
      loading: false,
      resultado_no_municipio: 0,
      resultado_na_equipe: 0,
      disableBtnSalvarSerie: true,
      arrayChartMunicipio: [],
      arrayChartEquipe: [],
      arrayChartMicroArea: [],
      max_yaxis: 0,
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      sexo: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      temEquipe: false,
      temAcs: false,
      groupFilterItems: [...groupFilterItems],
      groupFilter: { label: 'Ativos', value: 'ativos' },
      filterSearchTable: false,
      tabelaResultado: [],
      indicadorResultado: { label: 'CI e CDT atualizados', value: '33' },
      equipeDataNuIne: '',
      indicadorGrafico: { label: 'CI e CDT atualizados', value: '33' },
      optionsIndicador: [...optionsIndicador],
      resetarSelectTabelaResultado: false,
      dadosDoMapaOriginal: [],
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      labelColunaAtualizados: 'Atualizados e completos',
      labelColunaDesatualizados: 'Desatualizados ou incompletos',
      dadosSerieHistorica: [],
      dadosSisabEquipe: {
        min_cad: 0,
        max_cad: 0,
      },
      tituloGrafico: '',
      checkboxEquipeDadosDoMapa: false,
      disabledCheckboxEquipeDadosDoMapa: false,
      equipe: '',
      loadingLista: false,
      dadosMunicipioClassificacao: '',
      dadosEquipeClassificacao: '',
      dadosMicroAreaClassificacao: '',
      optionsIndicadorClassificacao: [...optionsIndicadorClassificacao],
      indicadorClassificacao: {
        label: 'Cadastro no e-SUS',
        value: 'por-cadastro-esus',
        indicador: '35',
      },
    }
  },
  computed: {
    _resultadoAcs() {
      return (this.populacaoIbge / this.dadosResultadoMicroArea.total) * 100
    },
    _municipio() {
      return {
        total: this.dadosResultadoMunicipio.total,
        atualizados: this.dadosResultadoMunicipio.atualizados,
        desatualizados: this.dadosResultadoMunicipio.desatualizados,
      }
    },
    _equipe() {
      return {
        total: this.dadosResultadoEquipe.total,
        atualizados: this.dadosResultadoEquipe.atualizados,
        desatualizados: this.dadosResultadoEquipe.desatualizados,
      }
    },
    _acs() {
      return {
        total: this.dadosResultadoMicroArea.total,
        atualizados: this.dadosResultadoMicroArea.atualizados,
        desatualizados: this.dadosResultadoMicroArea.desatualizados,
      }
    },
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.cadastros,
        this.idade_inicial,
        this.idade_final,
        this.sexo,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.groupFilter
      )
      if (response === undefined) {
        response = []
      }
      return response
    },

    dadosDoMapa() {
      return this.dadosDoMapaOriginal.filter((el) => {
        if (this.equipe != '') {
          return (
            el.ine == this.equipe.nu_ine &&
            el.latitude != null &&
            el.longitude != null
          )
        }
        return el
      })
    },
  },

  methods: {
    abrirAbaResultadoGrafico() {
      this.tabsActive2 === 1
      this.indicadorResultado = { label: 'CI e CDT atualizados', value: '33' }
      this.onChangeIndicadorResultado(this.indicadorResultado)
    },

    getRadiusMarker(item) {
      return Functions.getRadius(item)
    },

    getRadiusColor(item) {
      return Functions.getRadiusColor(item)
    },

    onChangeIndicadorGrafico(val) {
      if (val == null) {
        this.indicadorGrafico = {
          label: 'CI e CDT atualizados e 100% completos',
          value: '32',
        }
      }
      switch (val.value) {
        case '28':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL ATUALIZADO E COMPLETO FEITO PELA eSF E/OU eAP'
          break
        case '0':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL ATUALIZADO FEITO PELA eSF E/OU eAP'
          break
        case '27':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL COMPLETO FEITO PELA eSF E/OU eAP'
          break
        default:
          break
      }
      this.buscarDadosDoGrafico()
    },

    async onChangeIndicadorResultado(item) {
      switch (item.value) {
        case '28':
          this.labelColunaAtualizados = 'Atualizados e completos'
          this.labelColunaDesatualizados = 'Desatualizados ou incompletos'
          break
        case '0':
          this.labelColunaAtualizados = 'Atualizados'
          this.labelColunaDesatualizados = 'Desatualizados'
          break
        case '27':
          this.labelColunaAtualizados = 'Completos'
          this.labelColunaDesatualizados = 'Incompletos'
          break
        default:
          break
      }

      this.resetarSelectTabelaResultado = false
      this.indicadorResultado = item
      this.setarResultadoMunicipio()
      this.setarResultadoEquipe()
      this.setarResultadoMicroArea()
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    onChangeSexo(event) {
      this.sexo = event.target.value
    },

    cleanFilters() {
      this.idade_inicial = ''
      this.idade_final = ''
      this.sexo = ''
    },

    setarResultadoMunicipio() {
      const result = Functions.resultadoDoMunicipio(
        this.indicadorResultado,
        this.tabelaResultado
      )
      this.dadosResultadoMunicipio.total = result.total
      this.dadosResultadoMunicipio.atualizados = result.atualizados
      this.dadosResultadoMunicipio.desatualizados = result.desatualizados
      this.resultado_no_municipio = result.resultado
      this.$refs.graficoResultado.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.indicadorResultado
      )
    },

    setarResultadoEquipe() {
      const result = Functions.resultadoDaEquipe(
        this.indicadorResultado,
        this.tabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosResultadoEquipe.total = result.total
      this.dadosResultadoEquipe.atualizados = result.atualizados
      this.dadosResultadoEquipe.desatualizados = result.desatualizados
      this.resultado_na_equipe = result.resultado

      let responseEquipe = this.tabelaResultado.find((item) => {
        return item.ibge_ine == this.equipe.nu_ine
      })
      if (responseEquipe != undefined) {
        this.dadosSisabEquipe.min_cad = responseEquipe.min_cad
        this.dadosSisabEquipe.max_cad = responseEquipe.max_cad
      }
      this.$refs.graficoResultado.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.indicadorResultado,
        this.equipe
      )
    },

    async setarResultadoMicroArea() {
      if (this.micro_area != '') {
        const result = Functions.resultadoDaMicroArea(
          this.indicadorResultado,
          this.tabelaResultado,
          this.equipe.nu_ine,
          this.micro_area
        )
        this.dadosResultadoMicroArea.total = result.total
        this.dadosResultadoMicroArea.atualizados = result.atualizados
        this.dadosResultadoMicroArea.desatualizados = result.desatualizados
        this.resultado_na_micro_area = result.resultado
        this.$refs.graficoResultado.serieHistoricaMicroArea(
          this.dadosSerieHistorica,
          this.indicadorResultado,
          this.equipe,
          this.micro_area
        )
      }
    },

    onChangeIndicadorClassificacao(item) {
      this.setarClassificacaoMunicipio()

      if (item.value == 'por-cadastro-esus') {
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
        if (this.micro_area != '') {
          this.setarClassificacaoMicroArea()
        }
      }

      if (item.value == 'por-parametro') {
        this.dadosMunicipioClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        this.dadosMicroAreaClassificacao = {
          resultado: 0,
          escore: 0,
          classificacao: '-',
        }
        if (this.equipe != '') {
          this.setarClassificacaoEquipe()
        }
      }
    },

    setarClassificacaoMunicipio() {
      const result = Functions.resultadoClassificacaoMunicipio(
        this.indicadorClassificacao,
        this.tabelaResultado
      )
      this.dadosMunicipioClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        this.indicadorClassificacao
      )
    },

    setarClassificacaoEquipe() {
      const result = Functions.resultadoClassificacaoEquipe(
        this.indicadorClassificacao,
        this.tabelaResultado,
        this.equipe.nu_ine
      )
      this.dadosEquipeClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaEquipe(
        this.dadosSerieHistorica,
        this.indicadorClassificacao,
        this.equipe
      )
    },

    setarClassificacaoMicroArea() {
      const result = Functions.resultadoClassificacaoMicroArea(
        this.indicadorClassificacao,
        this.tabelaResultado,
        this.equipe.nu_ine,
        this.micro_area
      )
      this.dadosMicroAreaClassificacao = {
        resultado: result.resultado,
        escore: result.escore,
        classificacao: result.classificacao,
        dados: result.dados,
      }
      this.$refs.graficoClassificacao.serieHistoricaMicroArea(
        this.dadosSerieHistorica,
        this.indicadorClassificacao,
        this.equipe,
        this.micro_area
      )
    },

    async buscarDadosDaLista() {
      this.cleanFilters()
      this.loadingLista = true
      try {
        let response = await Functions.getCadastrosIndividuaisPorMicroArea(
          this.$store.state.cod_ibge,
          this.equipe.nu_ine,
          this.micro_area
        )
        if (response) {
          this.cadastros = response
          this.cadastrosOriginais = response
          this.exibirCadastrosVermelhos = true
          this.handleExibirVermelhos(true)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLista = false
      }
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true
        this.micro_area = this.$store.state.micro_area
        // dados da série histórica
        let response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[0,27,28,29,31,32,33,35,37,54]`
        )
        this.tabelaResultado = response2.data
        this.dadosSerieHistorica = response2.data
        // dados do município
        this.setarResultadoMunicipio()
        this.setarClassificacaoMunicipio()
        // dados da equipe
        let equipe = this.$store.state.equipesV2.find((el) => {
          return el.ine_esf_eap == this.$store.state.nu_ine
        })
        if (equipe) {
          this.equipe = {
            nu_ine: equipe.ine_esf_eap,
            no_equipe: equipe.no_esf_eap,
            nu_cnes: equipe.nu_cnes,
          }
          this.setarResultadoEquipe()
          this.setarClassificacaoEquipe()
        }
        // dados da microárea do acs
        this.setarResultadoMicroArea()
        this.setarClassificacaoMicroArea()
        this.buscarDadosDaLista()
        // dados do mapa
        this.buscarDadosDoMapa()
        let response3 = await this.$api.get(
          `/app/utils/equipes-br/${this.$store.state.cod_ibge}`
        )
        if (response3) {
          this.dadosDoMapaOriginal = response3.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    buscarDadosDoMapa() {
      this.$refs.componentMapa.buscarDadosDoMapa()
    },

    getRowColorTabelaMapa(item) {
      return Functions.getRowColorTabelaMapa(item)
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area,
        this.$store.state.sincronizadorC.ultimaAtualizacao
          .split('/')
          .reverse()
          .join('-')
      )
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.map-radius {
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #fff;
  font-weight: 700;
}
</style>
<style src="./styles.scss" scoped lang="scss" />
